import { Box } from '@material-ui/core'
import { MusicIcon } from 'common/icon-components/MusicIcon'
import { observer } from 'mobx-react'
import { musicPlayerState } from 'models/music-player/music-player.store'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

interface IPlayButtonProps {}

const StyledMusicButton = styled(Box)`
  && {
    cursor: pointer;
  }
`

export const MusicButton = observer(({}: PropsWithChildren<IPlayButtonProps>) => {
  const {
    paused,
    togglePaused
  } = musicPlayerState
  
  return (
    <StyledMusicButton
      onClick={() => {
        togglePaused()
      }}
    >
      <MusicIcon paused={paused} />
    </StyledMusicButton>
  )
})
